import { computed, inject, Injectable, signal } from '@angular/core';
import { TranslateRegistry } from 'src/app/services/translate/translate.registry';
import { ListingPageModel } from 'src/app/shared/components/listing-page/services/listing-page-model/listing-page-model.types';
import { ListingPageModelAbstract } from 'src/app/shared/components/listing-page/services/listing-page-model/listing-page-model-abstract';
import { ListingTableComponent } from 'src/app/shared/components/listing-table/listing-table.component';
import { ListingPageId } from '@portal/shared/components/listing-page/store/listing-page-store.types';
import { ListingPageModelRegistry } from '@portal/shared/components/listing-page/services/listing-page-model/listing-page-model-registry.service';
import { OrderDirection } from 'src/app/pages/equipment/devices/components/devices.models';
import { FieldOperationSortFieldName } from '../ui/field-operations.types';
import { FieldOperationsSidePanelComponent } from '../ui/side-panel/field-operations-side-panel.component';
import { FieldOperationsListingFiltersSourceService } from './field-operations-listing-filters-source.service';
import { FieldOperationsListingDataSourceService } from './field-operations-listing-data-source.service';
import { FieldOperationsListingExportConfigService } from './field-operations-listing-export-config.service';
import { createFieldOperationsColumns } from './field-operations-listing.columns';
import { FIELD_OPERATIONS_DEFAULT_SEARCH_TYPE, FIELD_OPERATIONS_SEARCH_TYPES } from './field-operations-listing.search';
import { FIELD_OPERATIONS_SORT_FIELD } from './field-operations-listing.sort';

@Injectable()
export class FieldOperationsServiceServiceListingModelService
  extends ListingPageModelAbstract
  implements ListingPageModel
{
  readonly listingPageModelRegistry = inject(ListingPageModelRegistry);

  readonly pageTitle = TranslateRegistry.get.INSTALLATION_HISTORY.TITLE.FIELD_OPERATIONS;
  readonly searchTypeList = signal(FIELD_OPERATIONS_SEARCH_TYPES);
  readonly selectedSearchType = signal(FIELD_OPERATIONS_DEFAULT_SEARCH_TYPE);
  readonly searchTextMaxLength = 64;

  readonly tableColumns = computed(() => createFieldOperationsColumns());
  readonly filterSource = inject(FieldOperationsListingFiltersSourceService);
  readonly dataSource = inject(FieldOperationsListingDataSourceService);
  readonly exportConfig = inject(FieldOperationsListingExportConfigService);

  readonly tableCmp = ListingTableComponent;
  readonly sorting = signal({
    columnName: FieldOperationSortFieldName.InstallationDateTimeUtc,
    orderDirection: OrderDirection.DESC
  });
  readonly sortField = FIELD_OPERATIONS_SORT_FIELD;
  readonly selectionFieldName = 'deviceUID';
  readonly sidePanelTitle = TranslateRegistry.get.INSTALLATIONS_SIDE_PANEL.TITLE.PROGRAMMING_DETAILS;
  readonly sidePanelBodyCmp = FieldOperationsSidePanelComponent;

  get pageId(): ListingPageId {
    return ListingPageId.FieldOperationsMetering;
  }

  constructor() {
    super();
    this.listingPageModelRegistry.add(ListingPageId.FieldOperationsMetering, this);
  }
}
